module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": _vm.title,
      "size": "relative_lg",
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.handleCloseModal()
      }
    }
  }, [_c('div', {
    staticClass: "flex flex-col rounded-md mx-6 h-full mb-6 space-y-5 overflow-y-auto"
  }, [_c('div', {
    staticClass: "relative h-44 w-full overflow-hidden rounded-lg"
  }, [_c('img', {
    staticClass: "w-full h-full object-cover rounded-lg",
    attrs: {
      "src": "/static/getting_started/getting_started.png",
      "alt": "Parlay"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "absolute inset-0 flex items-center justify-center"
  }, [_c('span', {
    staticClass: "text-white text-4xl font-semibold font-poppins select-none"
  }, [_vm._v("Welcome to Parlay!")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col flex-grow space-y-6 h-full overflow-y-auto"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-1.5"
  }, [_c('h3', {
    staticClass: "font-poppins text-blueGray-800 text-2xl font-semibold"
  }, [_vm._v("Ready for remarkably deep class discussions?")]), _vm._v(" "), _c('p', {
    staticClass: "text-blueGray-700 text-base"
  }, [_vm._v("Let's start your Parlay journey")])]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-1 xl:grid-cols-3 gap-x-3 gap-y-3"
  }, [_c('div', {
    staticClass: "bg-white border border-solid border-gray-200 rounded px-5 py-4 space-y-3"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-1.5"
  }, [_c('h5', {
    staticClass: "font-manrope text-base text-blueGray-800 font-bold"
  }, [_vm._v("Create a discussion activity")]), _vm._v(" "), _c('p', [_vm._v("Plan your first discussion activity in seconds!")])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('button', {
    staticClass: "hover:underline"
  }, [_vm._v("Learn more")]), _vm._v(" "), _c('button', {
    staticClass: "px-4 py-2 bg-primary rounded text-white hover:bg-primary-dark",
    on: {
      "click": function($event) {
        return _vm.handleCloseModal()
      }
    }
  }, [_vm._v("New RoundTable")])])]), _vm._v(" "), _c('div', {
    staticClass: "bg-white border border-solid border-gray-200 rounded px-5 py-4 space-y-3"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-1.5"
  }, [_c('h5', {
    staticClass: "font-manrope text-base text-blueGray-800 font-bold"
  }, [_vm._v("Browse Universe")]), _vm._v(" "), _c('p', [_vm._v("Explore over 7,000 teacher-created discussion prompts!")])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('button', {
    staticClass: "hover:underline"
  }, [_vm._v("Learn more")]), _vm._v(" "), _c('button', {
    staticClass: "px-4 py-2 bg-pinky rounded text-white hover:bg-pinky-dark",
    on: {
      "click": function($event) {
        return _vm.handleBrowseUniverse()
      }
    }
  }, [_vm._v("Browse Topics")])])]), _vm._v(" "), _c('div', {
    staticClass: "bg-white border border-solid border-gray-200 rounded px-5 py-4 space-y-3"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-1.5"
  }, [_c('h5', {
    staticClass: "font-manrope text-base text-blueGray-800 font-bold"
  }, [_vm._v("Explore Discussion Types")]), _vm._v(" "), _c('p', [_vm._v("Understand how Written and Verbal RoundTables work.")])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-end items-center"
  }, [_c('button', {
    staticClass: "px-4 py-2 bg-white border border-solid border-gray-200 rounded text-gray-800 hover:bg-gray-50",
    on: {
      "click": function($event) {
        return _vm.handleOpen()
      }
    }
  }, [_vm._v("Learn More")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-724978b3!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/Onboarding/Onboarding.vue
// module id = 2444
// module chunks = 61